import type { ReapproAlgorithmParamUpdate } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const updateReapproAlgorithmParams = async (params: ReapproAlgorithmParamUpdate[]) => {
  const response = await gozokiApiWithAuth.patch('/reappro-algorithms/params', {
    algorithmParams: params,
  })
  return response.data
}
